import { Link } from "@tanstack/react-router";
import { ZyntraLogo } from "@/components/ZyntraLogo";
import { getPaymentProviderSearch } from "@/lib/payment-provider";

export function Footer() {
  const providerSearch = getPaymentProviderSearch();

  return (
    <footer className="border-t border-border bg-surface">
      <div className="mx-auto max-w-7xl px-4 py-12 sm:px-6">
        <div className="grid gap-10 sm:grid-cols-2 lg:grid-cols-4">
          <div className="lg:col-span-2">
            <ZyntraLogo className="h-12 w-auto" />
            <p className="mt-4 max-w-sm text-sm text-muted-foreground">
              Plataforma segura de venta y reventa de entradas. Operada por Zyntra
              Events S.R.L., San José, Costa Rica.
            </p>
          </div>

          <div>
            <p className="text-xs font-semibold uppercase tracking-wider text-foreground">
              Plataforma
            </p>
            <ul className="mt-4 space-y-2.5 text-sm text-muted-foreground">
              <li>
                <Link to="/" className="transition-colors hover:text-foreground">
                  Explorar eventos
                </Link>
              </li>
              <li>
                <Link to="/resale" search={providerSearch as any} className="transition-colors hover:text-foreground">
                  Reventa
                </Link>
              </li>
              <li>
                <Link to="/wallet" className="transition-colors hover:text-foreground">
                  Wallet
                </Link>
              </li>
            </ul>
          </div>

          <div>
            <p className="text-xs font-semibold uppercase tracking-wider text-foreground">
              Legal
            </p>
            <ul className="mt-4 space-y-2.5 text-sm text-muted-foreground">
              <li>
                <Link to="/privacy" className="transition-colors hover:text-foreground">
                  Política de Privacidad
                </Link>
              </li>
              <li>
                <Link to="/terms" className="transition-colors hover:text-foreground">
                  Términos y Condiciones
                </Link>
              </li>
              <li>
                <Link to="/cookies" className="transition-colors hover:text-foreground">
                  Política de Cookies
                </Link>
              </li>
              <li>
                <a
                  href="mailto:legal@zyntratickets.com"
                  className="transition-colors hover:text-foreground"
                >
                  Contacto legal
                </a>
              </li>
            </ul>
          </div>
        </div>

        <div className="mt-10 border-t border-border pt-6">
          <p className="text-center text-xs text-muted-foreground sm:text-left">
            © {new Date().getFullYear()} Zyntra Events S.R.L. — Todos los derechos
            reservados. Plataforma segura de experiencias.
          </p>
        </div>
      </div>
    </footer>
  );
}
